<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Групп нэмэх</h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <label>Групп нэр</label>
                      <input
                        v-model.trim="lesson.name"
                        type="text"
                        class="form-control"
                        placeholder="Групп нэр"
                      />
                    </div>
                    <div class="form-group">
                      <label>Дэлгэрэнгүй</label>
                      <textarea
                        v-model.trim="lesson.description"
                        type="text"
                        class="form-control"
                        placeholder="Дэлгэрэнгүй"
                        rows="5"
                      />
                    </div>

                    <!-- <div class="row">
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1">Хичээл:</label>
                        <select class="form-control" v-model='lesson.lesson'>
                          <option v-for="type in lessons" v-bind:key="'sector-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                        </select>
                      </div>
                    </div> -->

                    <div
                      class="row"
                      v-if="
                        setTeacher &&
                        setTeacher == true &&
                        teachers &&
                        teachers.length > 0
                      "
                    >
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1"
                          >Бүлэгт хичээл заах багш багш:</label
                        >
                        <select class="form-control" v-model="selectedTeacher">
                          <option
                            v-for="teacher in teachers"
                            v-bind:key="'teacher-' + teacher.id"
                            v-bind:value="teacher"
                          >
                            {{ teacher.name }} - {{ teacher.code }} -
                            {{ teacher.email }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <hr />
                    <div class="row">
                      <div class="text-center col" style="cursor: pointer">
                        <a
                          class="small"
                          href="#"
                          style="cursor: pointer"
                          @click="$router.back()"
                          >Буцах</a
                        >
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "GroupAdd",
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  data() {
    return {
      lesson: {
        name: "",
        description: "",
      },
      performingRequest: false,
      teachers: [],
      selectedTeacher: null,
      sectors: [],
      lessons: [],
      school: null,
    };
  },
  methods: {
    async save() {
      this.performingRequest = true;
      if (this.lesson != null && this.lesson.name != "") {
        if (
          this.lesson.id != null &&
          this.lesson.id != "" &&
          this.lesson.id != "new"
        ) {
          this.lesson.name = this.capitalizeFirstLetter(this.lesson.name);
          this.lesson.modifiedUserId = this.$store.getters.currentUser.uid;
          this.lesson.modifiedUser = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          if (
            this.setTeacher &&
            this.setTeacher == true &&
            this.selectedTeacher &&
            this.selectedTeacher.ref
          ) {
            this.lesson.teacher = this.selectedTeacher.ref;
          } else if (
            this.$store.getters.userProfile != null &&
            this.$store.getters.userProfile.customer != null
          ) {
            this.lesson.teacher = this.$store.getters.userProfile.customer;
          }
          this.lesson.modifiedAt = new Date();
          this.lesson.school = null;
          if (this.schoolId) {
            this.lesson.school = fb.db.collection("schools").doc(this.schoolId);
          }
          this.lesson.startYear = this.school.currentYear;
          this.lesson.startMonth = this.school.currentYearStartMonth;
          this.lesson.currentSemesterNumber = this.school.currentSemesterNumber;
          await fb.db
            .collection("schools")
            .doc(this.schoolId)
            .collection("lessonGroups")
            .doc(this.lesson.id)
            .set(this.lesson);
          // if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
          //   this.lesson.teacher=this.$store.getters.userProfile.customer;
          // }
        } else {
          this.lesson.name = this.capitalizeFirstLetter(this.lesson.name);
          this.lesson.userId = this.$store.getters.currentUser.uid;
          this.lesson.user = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          if (
            this.setTeacher &&
            this.setTeacher == true &&
            this.selectedTeacher &&
            this.selectedTeacher.ref
          ) {
            this.lesson.teacher = this.selectedTeacher.ref;
          } else if (
            this.$store.getters.userProfile != null &&
            this.$store.getters.userProfile.customer != null
          ) {
            this.lesson.teacher = this.$store.getters.userProfile.customer;
          }
          this.lesson.createdAt = new Date();
          this.lesson.checkedAt = new Date();
          this.lesson.school = null;
    
          if (this.schoolId) {
            this.lesson.school = fb.db.collection("schools").doc(this.schoolId);
            fb.db
              .collection("schools")
              .doc(this.schoolId)
              .update({
                numberOfLessonGroups: fb.firestore.FieldValue.increment(1),
              });
          }
          this.lesson.startYear = this.school.currentYear;
          this.lesson.startMonth = this.school.currentYearStartMonth;
          this.lesson.currentSemesterNumber = this.school.currentSemesterNumber;

          await fb.db
            .collection("schools")
            .doc(this.schoolId)
            .collection("lessonGroups")
            .doc()
            .set(this.lesson);
          if (
            this.$store.getters.userProfile != null &&
            this.$store.getters.userProfile.customer != null
          ) {
            this.lesson.teacher = this.$store.getters.userProfile.customer;
          }
        }

        this.$router.back();
      } else {
        alert("Та группын нэр оруулна уу");
      }
    },
    setLesson() {
      this.lesson = {
        name: "",
        description: "",
      };
    },
    remove(index, array) {
      if (array != null && array.length > 0) array.splice(index, 1);
    },

    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    async _getCategories() {
      fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .orderBy("name")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((paymentData) => {
            let object = paymentData.data();
            object.ref = paymentData.ref;
            object.id = paymentData.id;
            this.lessons.push(object);
          });
        });

      fb.db
        .collection("schools/" + this.schoolId + "/sectors")
        .orderBy("name")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((paymentData) => {
            let object = paymentData.data();
            object.ref = paymentData.ref;
            object.id = paymentData.id;
            this.sectors.push(object);
          });
        });

      if (this.setTeacher && this.setTeacher == true) {
        var querySnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/teachers")
          .orderBy("name")
          .get();
        querySnapshot.forEach((paymentData) => {
          let object = paymentData.data();
          object.ref = paymentData.ref;
          object.id = paymentData.id;
          this.teachers.push(object);
        });
      }
    },
    _getQA() {
      if (this.groupId != null && this.groupId != "") {
        var docRef = fb.db
          .collection("schools/" + this.schoolId + "/lessonGroups")
          .doc(this.groupId)
          .get()
          .then((doc) => {
            this.lesson = doc.data();
            this.lesson.id = doc.id;

            if (this.lesson.teacher && this.teachers)
              for (const tttData of this.teachers) {
                if (tttData.id == this.lesson.teacher.id) {
                  this.selectedTeacher = tttData;
                }
              }
          })
          .catch(function (error) {
            console.log("Error getting document:", error);
          });
      }
    },
  },

  async created() {
    if (this.schoolId) {
      var schoolData = await fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get();
      let school = schoolData.data();
      school.id = schoolData.id;
      school.ref = schoolData.ref;
      this.school = school;

      await this._getCategories();
      this._getQA();
    }
  },
  props: {
    schoolId: {
      required: true,
    },
    setTeacher: {
      required: false,
    },
    groupId: {
      required: false,
    },
  },
};
</script>

